export function deepEqual(x: any, y: any): boolean {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y;
  return x && y && tx === 'object' && tx === ty
    ? ok(x).length === ok(y).length && ok(x).every(key => deepEqual(x[key], y[key]))
    : x === y;
}

export function replaceNullsWithEmptyStrings(data: Record<string, any> | null): any {
  if (!data) {
    return '';
  }

  if (Array.isArray(data)) {
    return data.map(item => replaceNullsWithEmptyStrings(item));
  }

  if (typeof data === 'object') {
    const newObj: { [key: string]: any } = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        newObj[key] = replaceNullsWithEmptyStrings(data[key]);
      }
    }
    return newObj;
  }

  return data;
}
